(() => {
  const DESKTOP_QUERY = '(min-width: 750px)';
  const SELECTOR_COMPARE = 'button.sp-button-compare, sp-button-compare, .sp-checkbox-compare, .snap-compare';
  const SELECTOR_SHOPPAY_WRAP = '.product-form__buttons .shopify-payment-button';
  const SELECTOR_SHOPPAY_BTN = '.shopify-payment-button__button';

  function removeCompareOnMobile(root = document) {
    if (window.matchMedia(DESKTOP_QUERY).matches) return;

    root.querySelectorAll(SELECTOR_COMPARE).forEach((el) => {
      el.remove();
    });
  }

  function placeCompareNextToShop(root = document) {
    if (!window.matchMedia(DESKTOP_QUERY).matches) {
      removeCompareOnMobile(root);
      return;
    }

    const compare = root.querySelector('button.sp-button-compare');
    const wrap = root.querySelector(SELECTOR_SHOPPAY_WRAP);
    if (!compare || !wrap) return;

    if (compare.dataset.novPlaced === '1') return;

    wrap.style.display = 'grid';
    wrap.style.gridTemplateColumns = '1fr 1fr';
    wrap.style.gap = '1rem';
    wrap.style.alignItems = 'stretch';

    const shopBtn = wrap.querySelector(SELECTOR_SHOPPAY_BTN);
    if (shopBtn) shopBtn.style.gridColumn = '1';

    compare.style.gridColumn = '2';
    compare.style.width = '100%';
    compare.style.margin = '0';

    wrap.appendChild(compare);

    compare.dataset.novPlaced = '1';
  }

  document.addEventListener('DOMContentLoaded', () => {
    removeCompareOnMobile();
    placeCompareNextToShop();
  });

  const obs = new MutationObserver(() => {
    removeCompareOnMobile();
    placeCompareNextToShop();
  });

  obs.observe(document.documentElement, { childList: true, subtree: true });
})();
